













































import { ButtonType } from '@getaccept/lib-ui';
import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  props: {
    isRejected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const reasonText = ref('');
    const isLoading = ref(false);

    const headerText = computed((): string =>
      props.isRejected ? t('document-successfully-rejected!') : t('reject-document')
    );
    const watchIsRejected = () => {
      if (props.isRejected) {
        isLoading.value = true;
      }
    };
    watch(() => props.isRejected, watchIsRejected);

    const handleReject = () => {
      isLoading.value = true;
      emit('rejectDocument', reasonText.value);
    };

    const handleClose = () => {
      emit('close');
    };

    return {
      ButtonType,
      reasonText,
      isLoading,
      headerText,
      watchIsRejected,
      handleReject,
      handleClose,
    };
  },
});
